module.exports = __webpack_public_path__ + "img/carshina21_02.b0392ccf.jpg";